<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      append-to-body
      width="780px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editFrom.cancel()"
    >
      <EditFrom
        ref="editFrom"
        :changeOrderCode="changeOrderCode"
        :data="data"
        @close="close()"
        @save="save()"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editFrom.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="save()">
          {{ $l('INDEX.save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditFrom from './index.vue'
export default {
  components: { EditFrom },
  props: {
    title: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    changeOrderCode: { type: String, default: '' },
    data: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {},
    }
  },
  methods: {
    save() {
      this.$refs.editFrom.getForm().then((res) => {
        if (!res) return
        this.close()
        this.$emit('confirm', res)
      })
    },
    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
